// src/components/Sidebar/index.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';     // ejemplo de ícono
import KitchenIcon from '@mui/icons-material/Kitchen';         // para Recetas
import ListIcon from '@mui/icons-material/List';               // para Ingredientes
import BannerIcon from '@mui/icons-material/ViewCarousel';     // para Banners
import TipIcon from '@mui/icons-material/Lightbulb';           // para Tips
import ScheduleIcon from '@mui/icons-material/Schedule';       // para Tiempo del día
import './Sidebar.css';

const Sidebar = ({ isVisible }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  if (!isVisible) return null;

  return (
    <div className="input">
      <button className="value" onClick={() => navigate('/dashboard')}>
        <DashboardIcon /> Dashboard
      </button>
      <button className="value" onClick={() => navigate('/dashboard/recetas')}>
        <KitchenIcon /> Recetas
      </button>
      <button className="value" onClick={() => navigate('/dashboard/ingredientes')}>
        <ListIcon /> Ingredientes
      </button>
      <button className="value" onClick={() => navigate('/dashboard/banners')}>
        <BannerIcon /> Banners
      </button>
      <button className="value" onClick={() => navigate('/dashboard/tips')}>
        <TipIcon /> Tips
      </button>
      <button className="value" onClick={() => navigate('/dashboard/tiempodia')}>
        <ScheduleIcon /> Tiempo del día
      </button>
      <button className="value" onClick={logout}>
        <LogoutIcon /> Logout
      </button>
    </div>
  );
};

export default Sidebar;
